import { Link, NavLink } from 'react-router-dom';
import { Warehouse } from 'lucide-react';
import { useAuthStore, homePathFor } from '../../store/useAuthStore';
import { BRAND_NAME } from '../../lib/brand';

/**
 * Header for the pages a stranger sees.
 *
 * Signed out it offers both doors. Previously it offered only "Sign in",
 * which meant the sign-up screen existed, worked, and was unreachable unless
 * you already knew the URL — the one page a new customer has to find.
 */
export default function PublicHeader({ transparent = false }) {
  const status = useAuthStore((s) => s.status);
  const user = useAuthStore((s) => s.user);

  return (
    <header className={`sticky top-0 z-30 border-b ${
      transparent
        ? 'border-transparent bg-white/80 backdrop-blur'
        : 'border-slate-200 bg-white'}`}>
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between gap-4 px-4 sm:px-6">
        <Link to="/" state={{ landing: true }} className="flex items-center gap-2"
              aria-label={`${BRAND_NAME} home`}>
          <span className="grid h-8 w-8 place-items-center rounded-lg bg-brand-600">
            <Warehouse className="h-4 w-4 text-white" aria-hidden="true" />
          </span>
          <span className="text-base font-extrabold tracking-tight text-slate-900">{BRAND_NAME}</span>
        </Link>

        <nav className="flex items-center gap-1 sm:gap-2">
          <NavLink to="/search"
                   className={({ isActive }) => `rounded-lg px-3 py-2 text-sm font-semibold ${
                     isActive ? 'text-brand-700' : 'text-slate-600 hover:text-slate-900'}`}>
            Find a space
          </NavLink>

          {status === 'signed_in' ? (
            <Link to={homePathFor(user.role)}
                  className="rounded-lg bg-brand-600 px-4 py-2 text-sm font-bold text-white hover:bg-brand-700">
              My account
            </Link>
          ) : (
            <>
              <Link to="/login" className="rounded-lg px-3 py-2 text-sm font-semibold text-slate-600 hover:text-slate-900">
                Sign in
              </Link>
              <Link to="/register"
                    className="rounded-lg bg-brand-600 px-4 py-2 text-sm font-bold text-white hover:bg-brand-700">
                Create account
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
